import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('RemoteDesktopExercise', LATEST_SCHEMA_VERSION.RemoteDesktopExercise);
export default exerciseTypeVersionAdapter;